import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import CountryCard from "../../components/CountryCard/CountryCard";
import "./Countries.css";
import NavBis from "../../components/NavBis/NavBis";
import { Link } from "react-router-dom";

function Countries() {
  const [countries, setCountries] = useState([]);

  const getCountries = async () => {
    const response = await fetch(
      "https://restcountries.com/v2/alpha?codes=qat,sen,NLD,gbr,USA,ARG,MEX,POL,FRA"
    );
    const FinalData = await response.json();
    setCountries(FinalData);
  };
  useEffect(() => {
    getCountries();
  }, []);

  return (
    <div>
      <Navbar />
      <br /> <br />
      <NavBis />
      <br /> <br />
      <div className="container">
        <div className="cardContainer">
          {countries.map((country) => (
            <div className="countryCard" key={country.numericCode}>
              <Link to={`/detail/${country.numericCode}`}>
                <CountryCard
                  key={country.numericCode}
                  image={country.flag}
                  format="card--medium"
                  description={country.name}
                />
              </Link>
            </div>
          ))}
        </div>
      </div>
      <br /> <br />
      <Footer />
    </div>
  );
}

export default Countries;
